import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2d006cde&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@/assets/pages/community/styles/index.response.css?vue&type=style&index=0&id=2d006cde&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d006cde",
  null
  
)

export default component.exports